// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-480e5966]{display:inline}.logo[data-v-480e5966],.logo img[data-v-480e5966]{height:1.3em}.name-container[data-v-480e5966]{display:flex;align-items:center}.comma[data-v-480e5966]{margin-right:2px}", ""]);
// Exports
module.exports = exports;
